<template>
  <form
    :ref="refFormTerminalData"
    @submit.prevent="submitEmitter"
  >
    <div class="emd-panel">
      <div class="emd-panel__section">
        <div class="emd-panel__block">
          <div class="el-chunk">
            <h2 class="emd-text _color_default _type_caption">
              {{ $t('title') }}
            </h2>
          </div>
        </div>
        <div class="emd-panel__block">
          <div class="el-chunk">
            <div
              class="emd-form-group"
              v-for="item in fields"
              :key="item"
            >
              <label
                class="emd-label"
                :for="item"
                >{{ $t(item) }}</label
              >
              <input
                v-model="form[item]"
                :data-testid="item"
                :disabled="disabled"
                :id="item"
                class="emd-input"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import FORM_CONTEXT_PHYSICAL_WORLD from '../forms-context.enum.js'
import PhysicalWorldFormDTO from '../PhysicalWorldFormDTO'

export default {
  name: 'FormTerminalData',
  props: {
    initialValues: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    fields: {
      type: Array,
      default: () => ['serialNumber', 'status', 'model', 'type', 'connection']
    }
  },
  data () {
    return {
      refFormTerminalData: FORM_CONTEXT_PHYSICAL_WORLD.FORM_TERMINAL_DATA,
      form: {
        serialNumber: '',
        status: '',
        model: '',
        type: '',
        connection: ''
      }
    }
  },
  mounted () {
    this.form = { ...this.form, ...this.initialValues }
  },
  methods: {
    submitEmitter () {
      new PhysicalWorldFormDTO().addItem(this.form)
    }
  }
}
</script>

<i18n>
    {
        "pt-BR": {
            "title": "Dados da Maquininha",
            "serialNumber": "Número de série",
            "status": "Status",
            "model": "Modelo",
            "type": "Tipo",
            "connection": "Conexão"
        },
        "en-US": {
            "title": "Terminal Data",
            "serialNumber": "Serial number",
            "status": "Status",
            "model": "Model",
            "type": "Type",
            "connection": "Connection"
        }
    }
</i18n>
